import React from "react";
import Home from "../pages/Home";
import Contactus from "./Contactus";
import SEO from "./SEO";

const Body = () => {
	return (
		<>
		<SEO 
			title="ReferMe - SPPU Engineering Notes, Study Materials & PYQs"
			description="Get SPPU engineering notes, study materials, and previous year question papers (PYQs). Access curated handwritten notes with branch-wise exam prep resources."
			keywords="SPPU notes, engineering notes, study materials, PYQ, previous year papers, exam preparation, university notes, CSE notes, ECE notes, mechanical notes, engineering study guide, referme"
				url="/"
			>
				<script type="application/ld+json">
				{JSON.stringify({
					"@context": "https://schema.org",
					"@type": "Product",
					"name": "Engineering Study Materials",
					"description": "Curated study notes and previous year papers for engineering students",
					"brand": {
						"@type": "Brand",
						"name": "ReferMe"
					},
					"offers": {
						"@type": "AggregateOffer",
						"priceCurrency": "INR",
						"lowPrice": "49",
						"highPrice": "999",
						"offerCount": "180+"
					}
				})}
				</script>
			</SEO>
			<div className="min-h-screen overflow-x-hidden overflow-y-hidden">
				<Home />
				<Contactus />
			</div>
		</>
	);
};

export default Body;
